import AddressSearchResults from './addressSearchResults';

export default AddressSearchResults;
